import * as Stimulus from "@hotwired/stimulus"

export class FormEnhancementsController extends Stimulus.Controller {
    static targets = ["submit"]

    connect() {
        const firstServerError = this.element.querySelector(
            "[data-fieldset-target=errorDisplay]:not(:empty)"
        );
        firstServerError?.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest"
        });
    }

    enableSubmit() {
        if (this.hasSubmitTarget) {
            this.submitTarget.disabled = false;
        }
    }
}
